// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b6aaa022","487":"75dd7f15","707":"5542ac26"}[chunkId] + ".chunk.js";
};